import React from 'react';
import { StickyHeader } from '../components/StickyHeader';
import { HeroSection } from '../components/HeroSection';
import { PainSection } from '../components/PainSection';
import { DreamSection } from '../components/DreamSection';
import { WhyFailsSection } from '../components/WhyFailsSection';
import { MechanismSection } from '../components/MechanismSection';
import { ProductSection } from '../components/ProductSection';
import { BenefitsSection } from '../components/BenefitsSection';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { FAQSection } from '../components/FAQSection';
import { FinalCTASection } from '../components/FinalCTASection';
import { FooterSection } from '../components/FooterSection';
export function LandingPage() {
  return <div className="min-h-screen bg-zinc-950 text-white" data-id="element-361">
      <StickyHeader data-id="element-362" />
      <HeroSection data-id="element-363" />
      <PainSection data-id="element-364" />
      <DreamSection data-id="element-365" />
      <WhyFailsSection data-id="element-366" />
      <MechanismSection data-id="element-367" />
      <ProductSection data-id="element-368" />
      <BenefitsSection data-id="element-369" />
      <GuaranteeSection data-id="element-370" />
      <FAQSection data-id="element-371" />
      <FinalCTASection data-id="element-372" />
      <FooterSection data-id="element-373" />
    </div>;
}